import axiosInstance from "./axios";
import { safeLogger } from "../utils/logger";
import { API_ENDPOINTS } from "../constants/api";


export const sendOtpToEmail = async (email: string, id: string) => {
  try {
    const response = await axiosInstance.post(API_ENDPOINTS.login.SEND_OTP, { email, id }, {
      headers: { "Content-Type": "application/json" }
    });

    safeLogger.log("OTP sent successfully");
    return response.data;
  } 
  catch (error: any) 
  {
    const serverMessage = error?.response?.data || error.message;
    safeLogger.error("Failed to send OTP");
    throw new Error(serverMessage);
  }
};


export const verifyOtpCode = async (email: string, code: string, id: string) => {
  safeLogger.log("Verifying OTP code");
  try {
    const response = await axiosInstance.post(API_ENDPOINTS.login.VERIFY_OTP, { email, code, id }, {
      headers: { "Content-Type": "application/json" }
    });

    // מחזיר את כל המידע שהשרת שלך מחזיר: { token, role, id }
    const { token, role, id: userId } = response.data;

    if (!token) {
      throw new Error("הקוד אומת אך לא התקבל טוקן מהשרת.");
    }

    safeLogger.log("OTP verified successfully");
    return { token, role, userId };
  } catch (error: any) {
    const message = error.response?.data || error.message;
    safeLogger.error("Failed to verify OTP");
    throw new Error(message);
  }
};



// New: Firebase-based Google login
export const loginByGoogleWithFirebase = async (token: string) => {
  try {
    const response = await axiosInstance.post(API_ENDPOINTS.login.GOOGLE, { token }, {
      headers: { "Content-Type": "application/json" },
    });
    
    safeLogger.log("Google login successful");
    return response.data;
  } catch (error: any) {
    const status = error?.response?.status;
    const serverMessage = error?.response?.data || error.message;

    safeLogger.error("Google login failed");

    if (status === 404) {
      throw new Error("משתמש לא קיים במערכת.");
    } else if (status === 401) {
      throw new Error("טוקן לא תקף. התחברות נכשלה.");
    } else {
      throw new Error("שגיאה בהתחברות עם גוגל.");
    }
  }
};

export function setSession(token: string) {
  localStorage.setItem("token", token);

  // ✅ מודיע לכל הקומפוננטות שהטוקן השתנה
  window.dispatchEvent(new Event("authChanged"));
}

export function removeSession() {
  localStorage.removeItem("token");
  window.dispatchEvent(new Event("authChanged"));
}

export function getSession() {
  return localStorage.getItem("token");
}
